// @flow
export const SELECTED: string = 'selected';
export const DEFAULT: string = `default`;
export const VIDEO: string = `video`;
export const GALLERY: string = `gallery`;
export const MODEL: string = `model`;
export const RESOURCE: string = `resource`;
export const STREAM: string = `stream`;
export const SET_SELECTED_TAB_NAME: string = 'set_selected_tab_name';
export const SELECTED_TAB_NAME: string = 'selectedTabName';

export const OPEN_DEFAULT: string = `openDefault`;
export const OPEN_VIDEO: string = `openVideo`;
export const OPEN_GALLERY: string = `openGallery`;
export const OPEN_MODEL: string = `openModel`;
export const OPEN_RESOURCE: string = `openResource`;
export const OPEN_STREAM: string = `openStream`;

export type ModulesAction = {
  type: string
};

export type Props = {
  [SELECTED]: string,
  openDefault: () => {},
  openVideo: () => {},
  openGallery: () => {},
  openModel: () => {},
  openResource: () => {},
  openStream: () => {},
}


// WEBPACK FOOTER //
// ./src/types/modules.jsx